/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Future value`)
};

const es_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor futuro`)
};

const de_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zukünftiger Wert`)
};

const nl_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toekomstige waarde`)
};

const fr_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur future`)
};

const it_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore futuro`)
};

const pt_br2_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor futuro`)
};

const pt_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor futuro`)
};

const ja_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将来価値`)
};

const zh_sip_result_future_value = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未来价值`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_result_future_value = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_result_future_value(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_result_future_value", locale)
	if (locale === "en") return en_sip_result_future_value(inputs)
	if (locale === "es") return es_sip_result_future_value(inputs)
	if (locale === "de") return de_sip_result_future_value(inputs)
	if (locale === "nl") return nl_sip_result_future_value(inputs)
	if (locale === "fr") return fr_sip_result_future_value(inputs)
	if (locale === "it") return it_sip_result_future_value(inputs)
	if (locale === "pt-BR") return pt_br2_sip_result_future_value(inputs)
	if (locale === "pt") return pt_sip_result_future_value(inputs)
	if (locale === "ja") return ja_sip_result_future_value(inputs)
	return zh_sip_result_future_value(inputs)
};